const getters = {
  // app
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,

  // user
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js